import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ISvg, SvgColor, SvgMatType } from 'src/app/constants/icons';

@Component({
    selector: 'mwp-svg-icon',
    templateUrl: './svg-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SVGIconComponent implements OnInit {
    @Input() SvgColor: SvgColor = SvgColor.stdIcon;
    @Input() SvgMatType: SvgMatType;
    @Input() ToolTipMessage: string;
    @Input() ToolTipClass: string;

    public svgSrc: string;
    
    constructor(
        private iconRegistry: MatIconRegistry, 
        private sanitizer: DomSanitizer
    ) {
    }

    ngOnInit() {
        // this.svgSrc = `../assets/images/svgs/${this.SvgMatType}.svg`;
        this.svgSrc = `assets/images/icons/${this.SvgMatType}.svg`;
        this.iconRegistry.addSvgIcon( 
            this.SvgMatType,
            this.sanitizer.bypassSecurityTrustResourceUrl(this.svgSrc)
    );
    }
}